export default __webpack_public_path__ + "static/realWorldImg4-b0d4905e1f1804313ce588b937002697.png";